import React from 'react';
import { Modal, Offcanvas } from 'react-bootstrap';
import CouponForm from './CouponForm';
import { borderColor, borderRadius, padding } from '@mui/system';

const CouponPopup = ({ show, handleClose, isMobile, coupon, setCoupon, applyCoupon, availableCoupons }) => {
  console.log(availableCoupons)
  return isMobile ? (
    <Offcanvas show={show} onHide={handleClose} placement="bottom" style={{height:'60%',borderRadius:'30px 30px 0px 0px' ,borderColor:'#0c609c',padding:'20px'}}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Apply Coupon</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <CouponForm
          coupon={coupon}
          setCoupon={setCoupon}
          applyCoupon={applyCoupon}
          availableCoupons={availableCoupons}
        />
      </Offcanvas.Body>
    </Offcanvas>
  ) : (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Apply Coupon</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CouponForm
          coupon={coupon}
          setCoupon={setCoupon}
          applyCoupon={applyCoupon}
          availableCoupons={availableCoupons}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CouponPopup;
